/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );
  // const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  // console.log('desc', metaDescription);
  // console.log('title', defaultTitle);

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: `Hi! I make awesome things for awesome people.`,
        },
        {
          property: `og:site_name`,
          content: `Portfolio - Subhendu Maji`,
        },
        {
          property: `og:title`,
          content: `Subhendu Maji`,
        },
        {
          property: `og:description`,
          content: `Hi! I make awesome things for awesome people.`,
        },
        {
          property: `og:image`,
          itemprop: `image`,
          content: `https://ik.imagekit.io/protechtest/210x297_2KqZ1iuck.jpg`,
        },
        {
          property: `og:image:width`,
          content: `300`,
        },
        {
          property: `og:image:height`,
          content: `300`,
        },
        {
          property: `og:image:type`,
          content: `image/jpeg`,
        },

        {
          property: `og:url`,
          content: `https://subhendu.ml`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `Hi! I make awesome things for awesome people.I am a software engineer with 6 months of experience residing in
          Delhi, India. I have worked with and for names such as iDreamCareer.com
          and Protech Engineering. I'm comfortable with a variety of tools.
          Typically I'll be digging in with ReactJS.`,
        },

        {
          name: `twitter:title`,
          content: `Subhendu Maji`,
        },
        {
          name: `twitter:url`,
          content: `https://subhendu.ml`,
        },
        {
          name: `twitter:description`,
          content: `Hi! I make awesome things for awesome people.`,
        },
        {
          name: `twitter:image`,
          content: `https://ik.imagekit.io/protechtest/210x297_2KqZ1iuck.jpg`,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
